import { useState } from "react"
import { addWeeks } from "date-fns"
import { getStartOfCurrentWeekUTC } from "~/utils/datetime"

export const FROZEN_WINDOW_WEEKS = 104

export const frozenForwardWindowEnd = (weeks: number = FROZEN_WINDOW_WEEKS) =>
  addWeeks(getStartOfCurrentWeekUTC(), weeks)

/**
 * Locks a forward calculation window at mount so that picker-driven date ranges
 * don't invalidate query keys for calculation inputs (forecast, future closing
 * stock, suggested orders, weeks-on-hand).
 *
 * Display ranges still float with the picker; only `forwardStart`/`forwardEnd`
 * stay stable for the component's lifetime.
 *
 * `weeks` sizes the window. Widen it only for callers whose display can reach past
 * the default two years — the suggested-order simulation steps once per purchase
 * interval up to `forwardEnd`, so a longer window is a proportionally slower query
 * for every user of that screen, not just the ones who scroll out that far.
 */
export const useFrozenForwardWindow = (weeks: number = FROZEN_WINDOW_WEEKS) => {
  const [range] = useState(() => {
    const forwardStart = getStartOfCurrentWeekUTC()
    return { forwardStart, forwardEnd: addWeeks(forwardStart, weeks) }
  })
  return range
}
